import React, { useEffect, useRef } from 'react';
import './Newsletter.css';
import { getNewsletterContent } from '../utils/contentLoader';

function Newsletter() {
  const timelineRef = useRef(null);

  useEffect(() => {
    // Load X/Twitter widget script
    const script = document.createElement('script');
    script.src = 'https://platform.twitter.com/widgets.js';
    script.async = true;
    script.charset = 'utf-8';

    script.onload = () => {
      // Re-render the timeline widget after script loads
      if (window.twttr && window.twttr.widgets && timelineRef.current) {
        window.twttr.widgets.load(timelineRef.current);
      }
    };

    document.head.appendChild(script);

    return () => {
      // Clean up script on unmount
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <section className="newsletter" id="latest">
      <div className="newsletter-container">
        <div className="newsletter-content newsletter-panel">
          <div className="newsletter-icon">
            <span className="newsletter-x-icon">𝕏</span>
          </div>

          <h3 className="newsletter-heading">{getNewsletterContent().heading || "Latest from X"}</h3>

          <p className="newsletter-description">
            {getNewsletterContent().description || "Follow along for real-time updates, Web3 insights, and behind-the-scenes of my journey as a builder."}
          </p>

          <a
            href="https://twitter.com/homeMetaX"
            target="_blank"
            rel="noopener noreferrer"
            className="newsletter-button"
          >
            Follow @homeMetaX on X
          </a>
        </div>

        <div className="newsletter-feed newsletter-panel" ref={timelineRef}>
          <div className="newsletter-feed-header">
            <div>
              <p className="newsletter-feed-eyebrow">{getNewsletterContent().eyebrow || "Live Feed"}</p>
              <h3>{getNewsletterContent().latestDrops || "Recent posts"}</h3>
            </div>
          </div>
          <div className="x-timeline-wrapper">
            <a
              className="twitter-timeline"
              data-theme="dark"
              data-chrome="noheader nofooter noborders transparent"
              data-tweet-limit="5"
              href="https://twitter.com/homeMetaX"
            >
              Loading posts from @homeMetaX...
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Newsletter;
